import ApiConstant from "../../constants/api.constants";
import api from "../api";
import {
  ParetoAnalysisFilter,
  ParetoAnalysisResponse,
  RFMSegmentationFilter,
  RFMSegmentationResponse,
  HighValueAtRiskFilter,
  HighValueAtRiskResponse,
} from "../../models/customer-analytics/customer-analytics.model";

const getParetoAnalysis = async (
  filter: ParetoAnalysisFilter
): Promise<ParetoAnalysisResponse> => {
  try {
    const response = await api
      .post(ApiConstant.customerAnalyticsParetoAnalysis, filter)
      .then((result: any) => {
        if (result) {
          return result.data;
        }
        return null;
      })
      .catch((error: any) => {
        console.error("Error fetching pareto analysis:", error);
        throw error;
      });

    return response || { totalRecords: 0, data: [] };
  } catch (e) {
    console.error("Error in getParetoAnalysis:", e);
    return { totalRecords: 0, data: [] };
  }
};

const getRFMSegmentation = async (
  filter: RFMSegmentationFilter
): Promise<RFMSegmentationResponse> => {
  try {
    const response = await api
      .post(ApiConstant.customerAnalyticsRFMSegmentation, filter)
      .then((result: any) => {
        if (result) {
          return result.data;
        }
        return null;
      })
      .catch((error: any) => {
        console.error("Error fetching RFM segmentation:", error);
        throw error;
      });

    return response || { totalRecords: 0, data: [] };
  } catch (e) {
    console.error("Error in getRFMSegmentation:", e);
    return { totalRecords: 0, data: [] };
  }
};

const getHighValueCustomersAtRisk = async (
  filter: HighValueAtRiskFilter
): Promise<HighValueAtRiskResponse> => {
  try {
    const response = await api
      .post(ApiConstant.customerAnalyticsHighValueAtRisk, filter)
      .then((result: any) => {
        if (result) {
          return result.data;
        }
        return null;
      })
      .catch((error: any) => {
        console.error("Error fetching high value at risk:", error);
        throw error;
      });

    return response || { totalRecords: 0, data: [] };
  } catch (e) {
    console.error("Error in getHighValueCustomersAtRisk:", e);
    return { totalRecords: 0, data: [] };
  }
};

const customerAnalyticsService = {
  getParetoAnalysis,
  getRFMSegmentation,
  getHighValueCustomersAtRisk,
};

export default customerAnalyticsService;
